import { render, staticRenderFns } from "./MultName.vue?vue&type=template&id=318d59df"
import script from "./MultName.vue?vue&type=script&lang=js"
export * from "./MultName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports